import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";

const navLinks = [
  { to: "/products", label: "Products" },
  { to: "/about", label: "About" },
  { to: "/pricing", label: "Pricing" },
  { to: "/contact", label: "Contact" },
];

export default function Navigation() {
  const [open, setOpen] = useState(false);

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-40 w-full border-b border-slate-200/70 bg-white/90 backdrop-blur"
    >
      <div className="lulo-container flex h-16 items-center justify-between">
        <Link
          to="/"
          data-testid="nav-wordmark"
          aria-label="Lulo Software — home"
          className="flex items-center"
          onClick={() => setOpen(false)}
        >
          <img
            src="/logo-full.png"
            alt="Lulo Software"
            className="h-9 sm:h-10 w-auto select-none"
            width="1451"
            height="356"
            decoding="async"
          />
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {navLinks.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className={({ isActive }) =>
                `text-sm transition-colors ${
                  isActive
                    ? "text-[#0A2540] font-semibold"
                    : "text-slate-600 hover:text-[#0A2540]"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <Link
            to="/contact"
            data-testid="nav-cta-contact"
            className="inline-flex items-center rounded-md bg-[#0A2540] px-3.5 py-2 text-sm font-medium text-white transition-colors hover:bg-[#081c30]"
          >
            Get in touch
          </Link>
        </nav>

        <button
          data-testid="nav-mobile-toggle"
          aria-label="Toggle navigation"
          className="md:hidden inline-flex h-10 w-10 items-center justify-center rounded-md text-slate-700 hover:bg-slate-100"
          onClick={() => setOpen((v) => !v)}
        >
          {open ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>

      {open && (
        <div
          data-testid="nav-mobile-menu"
          className="md:hidden border-t border-slate-200 bg-white"
        >
          <div className="lulo-container py-4 flex flex-col gap-1">
            {navLinks.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                onClick={() => setOpen(false)}
                data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
                className={({ isActive }) =>
                  `rounded-md px-3 py-3 text-sm ${
                    isActive
                      ? "bg-slate-100 text-[#0A2540] font-semibold"
                      : "text-slate-700 hover:bg-slate-50"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <Link
              to="/contact"
              onClick={() => setOpen(false)}
              data-testid="nav-mobile-cta-contact"
              className="mt-2 inline-flex items-center justify-center rounded-md bg-[#0A2540] px-3.5 py-3 text-sm font-medium text-white hover:bg-[#081c30]"
            >
              Get in touch
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
